import common from './common'
import download from './download'
import email from './email'
import eventSettings from './eventSettings'
import eventinfo from './eventinfo'
import exhibitors from './exhibitors'
import files from './files'
import home from './home'
import login from './login'
import password from './password'
import questions from './questions'
import leads from './leads'

const translations = {
  common,
  download,
  email,
  eventinfo,
  exhibitors,
  files,
  home,
  login,
  password,
  questions,
  eventSettings,
  leads
}

export default translations
